<template>
  <div class="foot-tabs-wrap">
    <ul>
      <template v-for="(v, n) in menus">
        <li
          :id="v.name"
          :key="n"
          :class="{ selected: currentSelect === v.path }"
          @click="hanldeMenu(v)"
          v-if="v.enable"
        >
          <div style="height: 28px; display: block">
            <i
              class="iconfont"
              :class="v.iconClsActive"
              v-if="currentSelect === v.path"
              style="font-size: 18px; color: var(--main-text-color)"
            ></i>
            <i class="iconfont" :class="v.iconCls" v-else style="font-size: 18px"></i>
          </div>
          <span class="icon-text">{{ v.title }}</span>
        </li>
      </template>
    </ul>
  </div>
</template>

<script type="text/javascript">
import $JourneyPlan from '../data/journeyPlan'
import { i18n } from 'app-core/lib/i18n'
const buriedPoint = function (code, params = {}) {
  window.$ztDataAction &&
    window.$ztDataAction.push({
      action: 'aplus.record',
      arguments: [code, 'CLK', params]
    })
}
export default {
  name: 'footer-menu',
  data() {
    return {
      currentSelect: location.pathname,
      iconPrefix: 'com',
      menus: [
        {
          title: i18n.t('APP_HOME.shou-ye'),
          name: 'home',
          path: $ZConfig.getVal('H5_HOME_URL') ? $ZConfig.getVal('H5_HOME_URL') : '/home',
          iconCls: 'shouye1',
          iconClsActive: 'shouye-xuanzhong',
          active: false,
          enable: true
        },
        {
          title: i18n.t('APP_HOME.chu-hang'),
          name: 'journeyList',
          path: '/mg/bi/subsidy/journeyList',
          // outPath: $ZConfig.getVal('H5_TRAVEL_REQUEST_LINK'), // 科大讯飞定制外链
          iconCls: 'hangchengweixuanzhong',
          iconClsActive: 'hangchengxuanzhong1',
          active: false,
          enable: window.localStorage.getItem('NAV_BAR_JOURNEY') === 'true'
        },
        {
          title: i18n.t('APP_HOME.ding-dan'),
          name: 'order',
          path: '/mg/bi/subsidy/myOrder',
          iconCls: 'dingdan21',
          iconClsActive: 'dingdan-xuanzhong',
          active: false,
          enable: true
        },
        {
          title: i18n.t('APP_HOME.bao-xiao'),
          name: 'expense',
          path: '/mg/expense',
          iconCls: 'baoxiao1',
          iconClsActive: 'baoxiao-xuanzhong',
          active: false,
          enable: $ZConfig.getVal('ER_PARTNER_SWITCH_COMPANY') != '2'
        },
        {
          title: i18n.t('APP_HOME.guan-li'),
          name: 'management',
          path: '/common/management',
          iconCls: 'guanli1',
          iconClsActive: 'guanli-xuanzhong',
          active: false,
          enable: !!$ZConfig.getVal('TM_H5_MANAGE_MODULE_SWITCH')
        },
        {
          title: i18n.t('APP_HOME.wo-de'),
          name: 'mypage',
          path: '/common/mypage',
          iconCls: 'wode2',
          iconClsActive: 'wode-xuanzhong1',
          active: false,
          enable: true
        }
      ],
      orderTimer: undefined,
      localStore: {
        orderNum: {
          waitPayNum: undefined,
          waitAuthNum: undefined
        }
      },
      expenseUrl: ''
    }
  },
  mounted() {
    window.addEventListener('popstate', this.routerWatcher)
    let outUrl = window.$ZConfig && window.$ZConfig.getVal('EC_SYS_THIRD_URL')

    if (outUrl) {
      window.$httpUtil.get(outUrl).then(({ data }) => {
        // console.log(JSON.stringify(data))
        if (data && data.redirectUrl) {
          console.log('expenseUrl', data.redirectUrl)
          // window.location.href = data.redirectUrl
          this.expenseUrl = data.redirectUrl
        }
      })
    }
    // trace.tag('RENDER_FOOTBAR')
    this.menus = this.menus.map((item) => {
      return {
        ...item,
        iconCls: this.iconPrefix + '-' + item.iconCls,
        iconClsActive: this.iconPrefix + '-' + item.iconClsActive
      }
    })
    this.handleGetJourneySwitch()
  },
  beforeUnmount() {
    window.removeEventListener('popstate', this.routerWatcher)
  },
  methods: {
    routerWatcher() {
      this.currentSelect = location.pathname
    },
    handleGetJourneySwitch() {
      $JourneyPlan
        .journeySwitch()
        .then((res) => {
          const isJourneyEnabled = res.data.data.journeySwitch && window.$ZConfig.getVal('PT_JOURNEY_PLAN_ENABLE')
          localStorage.setItem('NAV_BAR_JOURNEY', isJourneyEnabled ? 'true' : 'false')
          this.menus[1].enable = isJourneyEnabled
        })
        .catch((error) => {
          console.error('Error fetching journey switch config:', error)
        })
    },

    hanldeMenu(item) {
      this.currentSelect = item.path
      setTimeout(() => {
        if (window.$flutter) {
          window.$flutter.haptic()
        }
      }, 100)
      // if (item.outPath) {
      //   window.$jump.goLocPage(item.outPath, null, false)
      //   return
      // }
      if (item.name == 'home') {
        // 首页埋点事件
        buriedPoint('Button_Click_NAV_HomePage')
      }
      if (item.name == 'management') {
        // 管理埋点事件
        buriedPoint('Button_Click_NAV_Management')
      }
      if (item.name == 'management') {
        // 我的埋点事件
        buriedPoint('Button_Click_NAV_My_HomePage')
      }
      if (item.name == 'order') {
        // 订单事件
        buriedPoint('Button_Click_NAV_ORDER')
      }
      if (item.name === 'expense') {
        // 报销埋点事件
        // window.mconsole && window.mconsole.startUploadByPage('page_time_expense_my_expense_click')
        buriedPoint('Button_Click_NAV_Expense')
        if (this.expenseUrl !== '') {
          window.location.href = this.expenseUrl
        } else {
          window.$jump.goLocPage(item.path, null, true)
        }
      } else {
        window.$jump.goLocPage(item.path, null, true)
      }
      window.localStorage.setItem('SELECTED_TAB', '')
    }
  }
}
</script>

<style lang="less" scoped>
.svg-icon {
  width: 20px;
  height: 20px;
  vertical-align: -0.15em;
  fill: currentColor;
  font-weight: normal;
  overflow: hidden;
}

.icon-text {
  color: #333;
}

.foot-tabs-wrap {
  padding-bottom: var(--safe-area-inset-bottom);
  font-size: 14px;
  width: 100%;
  min-height: 60px;
  border-top: 1px solid #ecedef;
  z-index: 99;
  background-color: #ffffff;

  ul {
    margin-top: 3px;
    display: flex;

    li {
      position: relative;
      font-size: 12px;
      flex: 1;
      padding: 6px;
      text-align: center;
      color: #d9d9d9;
      line-height: 1.4;
      .iconfont {
        color: #333;
      }
      &:active {
        .iconfont,
        .icon-text {
          color: var(--main-text-color);
        }
      }
      span {
        color: rgba(0, 0, 0, 0.45);
      }

      .icon-zvg {
        color: #333;
      }

      .wxm-red-dot {
        position: absolute;
        color: red;
        top: -8%;
        left: 50%;
        font-size: 28px;
      }
    }

    li.selected {
      span {
        color: var(--main-text-color);
      }

      img {
        opacity: 1;
      }
    }

    li.noColor {
      color: #d9d9d9;

      span {
        color: rgba(0, 0, 0, 0.45);
      }
    }
  }
}
</style>
